export default class Utilities {
  static getEnvironment() {
    let env = 'prod';
    if (location && location.href){
      env = location.href.indexOf('localhost') > -1 ? 'dev':  (
        location.href.indexOf('star2star.net') > -1 ? 'test': 'prod');

    }
    //console.log('getEnvironment returning: ', env, location.href)
    return env;
  }

  static phoneNumberValidation(number) {
    return number !== undefined && number.length >= 1;
  }
}



// WEBPACK FOOTER //
// ./src/js/utilities.js